import * as actionTypes from './actionTypes'

export const search = (term) => { 
    return {
        type: actionTypes.SEARCH,
        term: term
    }
};

export const show_modal = (modal) => {
    return {
        type: actionTypes.SHOW_MODAL,
        modal: modal
    }
}